import React from "react";
import { Link } from "react-router-dom";
import { Navbar, Footer } from "@/components/yc/Nav";
import { CheckCircle2, ShieldCheck, GraduationCap, Lock } from "lucide-react";

const portrait = "https://customer-assets-v7afamib.emergentagent.net/job_vetted-hub-build/artifacts/jy8d8740_image.jpg";

const CreatorsLanding = () => {
    return (
        <div className="min-h-screen bg-yc-cream">
            <Navbar />
            <section className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                <div>
                    <div className="yc-overline">For Creators</div>
                    <h1 className="font-heading text-5xl md:text-6xl font-black tracking-tighter mt-4 leading-tight">Get briefed by brands<br /><span className="bg-yc-pink text-white inline-block px-3 -rotate-1">who pay.</span></h1>
                    <p className="text-lg text-yc-ink/80 mt-6 leading-relaxed">
                        Curated Chaos is free for creators. No application fees. No commission until you earn. Just briefs from vetted brands and protected payment on every job.
                    </p>
                    <div className="mt-8 flex gap-4">
                        <Link to="/login?role=creator" data-testid="creators-apply" className="yc-btn-accent">Apply now</Link>
                        <Link to="/" className="yc-btn-secondary">Back to home</Link>
                    </div>
                </div>
                <div className="yc-card overflow-hidden aspect-square">
                    <img src={portrait} alt="Curated Chaos creator" className="w-full h-full object-cover object-center" />
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="yc-card p-6">
                    <CheckCircle2 className="w-6 h-6 text-yc-blue" />
                    <h3 className="font-heading text-xl font-bold mt-3">100% free to join</h3>
                    <p className="text-sm text-yc-ink/75 mt-2 leading-relaxed">No application fee. No subscription. No commission cuts unless you&apos;ve been paid.</p>
                </div>
                <div className="yc-card p-6">
                    <CheckCircle2 className="w-6 h-6 text-yc-blue" />
                    <h3 className="font-heading text-xl font-bold mt-3">Real briefs only</h3>
                    <p className="text-sm text-yc-ink/75 mt-2 leading-relaxed">Briefs come from paying brands, matched by a strategist. No spam, no time-wasters.</p>
                </div>
                <div className="yc-card p-6">
                    <Lock className="w-6 h-6 text-yc-blue" />
                    <h3 className="font-heading text-xl font-bold mt-3">Payment protection</h3>
                    <p className="text-sm text-yc-ink/75 mt-2 leading-relaxed">Your payment is paid straight into your bank once all footage has been uploaded.</p>
                </div>
            </section>

            {/* UK Vetting + Leicester accreditation */}
            <section className="max-w-7xl mx-auto px-6 md:px-12 py-12">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div className="yc-card p-8 bg-yc-blue text-white">
                        <ShieldCheck className="w-10 h-10" />
                        <div className="yc-overline text-white mt-4">UK-screened</div>
                        <h3 className="font-heading text-3xl font-bold mt-2 text-white">Vetted by our UK team.</h3>
                        <p className="mt-3 text-white/90 leading-relaxed">All creators are screened and vetted through our UK team — for quality, professionalism and brand safety. Brands trust us because we&apos;ve already trusted you.</p>
                    </div>
                    <div className="yc-card p-8">
                        <div className="flex items-center gap-3">
                            <GraduationCap className="w-10 h-10 text-yc-pink" />
                            <span className="yc-badge bg-yc-pink text-white">Coming soon</span>
                        </div>
                        <div className="yc-overline mt-4">Accredited certification</div>
                        <h3 className="font-heading text-3xl font-bold mt-2">Recognised by the industry.</h3>
                        <p className="mt-3 text-yc-ink/80 leading-relaxed">A further accredited certification for content creation will be available soon — recognised by the industry, <span className="font-bold">in partnership with various universities across the UK</span>.</p>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default CreatorsLanding;
